import React from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@material-ui/core'
import { Teacher } from '../../../interfaces/examiner/Teacher'

interface Props {
    teacher: Teacher
    open: boolean
    loading: boolean
    error: string | null
    onClose: () => void
    onConfirm: () => void
}

export default function LoginAsTeacherDialog({ teacher, open, loading, error, onClose, onConfirm }: Props) {
    return (
        <Dialog open={open} onClose={loading ? undefined : onClose} aria-labelledby="login-as-teacher-dialog-title">
            <DialogTitle id="login-as-teacher-dialog-title">Login as Teacher</DialogTitle>
            <DialogContent>
                <Typography variant="body1" paragraph>
                    Log in as teacher <strong>{teacher.name}</strong> ({teacher.schoolCode})?
                </Typography>
                <Typography variant="body2" color="textSecondary">
                    You will have full access to their account. This action is logged.
                </Typography>
                {error && (
                    <Typography variant="body2" color="error" style={{ marginTop: 16 }}>
                        {error}
                    </Typography>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={loading}>
                    Cancel
                </Button>
                <Button onClick={onConfirm} color="primary" variant="contained" disabled={loading}>
                    {loading ? 'Logging in...' : 'Login as Teacher'}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
